export const FINANCING_ENDING_STATUS_SEPARATOR = ' · ';
